import styles from "./TableHeader.module.scss";
import cn from "classnames";
import { TableHeadItem } from "../tableHead";
import { useIntl } from "react-intl";
import useMediaQuery from "@utils/hooks/utils";
import arrow from "@assets/redesign/icons/arrow.svg";
import Icon from "@components/global/new/Icon/Icon";
import {
  MTSort,
  MinersSortState,
  SortDirection,
  serverSortingCode,
} from "@services/getMinerList";
import { MinerSortFields } from "../useMinersTableControl";
import { dev } from "@utils/dev";
import minerTableHeaders, { MinersTableHeaderId } from "./minerTableHeaders";
import { Checkbox } from "antd";

interface TableHeadProps {
  readonly isAdmin: boolean;
  readonly sort: MinersSortState;
  readonly rowsStyles: React.CSSProperties[];
  setSortBy: (value?: MinerSortFields) => void;
  checkboxTitle?: string;
  checkboxText?: string;
  selectedAll?: boolean;
  onSelectAll?: VoidFunction;
}

export default function TableHeader({
  isAdmin,
  rowsStyles,
  sort,
  setSortBy,
  ...props
}: //getdStyle,
TableHeadProps) {
  // dev.log("render: TableHeader", { isAdmin });

  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery("min", 1025); // see variables.scss / $viewport--md

  const onSortClicked = (itemSort?: MinerSortFields) => {
    return itemSort !== undefined ? setSortBy(itemSort) : null;
  };

  const getHeader = () =>
    minerTableHeaders.filter(
      (i) => isAdmin || i.id !== MinersTableHeaderId.CUSTOMER
    );

  return (
    <>
      <Checkbox
        className={styles.selectAll}
        checked={props.selectedAll}
        title={props.checkboxTitle}
        onChange={e => {
          if (e.target.checked && props.onSelectAll) {
            props.onSelectAll();
          }
        }}
      >
        {
          //props.checkboxText
        }
      </Checkbox>
      {getHeader().map((item, i) => (
        <div
          className={styles.head_item}
          onClick={() => onSortClicked(item.sort)}
          key={i}
          style={{
            ...rowsStyles[i === 6 ? 7 : i],
          }}
        >
          <label>{formatMessage({ id: item.messageId })}</label>
          {serverSortingCode(sort) === item.sort && (
            <Icon
              src={arrow}
              className={cn(styles.sortIcon, {
                [styles.active]: sort[1] === SortDirection.Desc,
              })}
              noHover
            />
          )}
        </div>

        /*
        <div
          data-testid="table-head-item"
          className={styles.head_item}
          onClick={() => onSortClicked(item.sort)}
          key={i}
          style={{
            ...rowsStyles[i === 6 ? 7 : i],
            ...(isDesktop && i === minerTableHeaders.length - 1
              ? { justifyContent: "flex-end" }
              : {}),
          }}
        >
          <label>{formatMessage({ id: item.messageId })}</label>
          {control.serverSortingCode(control.sort) === item.sort && (
            <Icon
              src={arrow}
              className={cn(styles.sortIcon, {
                [styles.active]:
                  control.sort[1] === SortDirection.Desc,
              })}
              disHover
            />
          )}

          {sort === item.sort && (
            <Icon
              src={arrow}
              className={cn(styles.sortIcon, {
                [styles.active]: sort2[1] === SortDirection.Desc,
              })}
              disHover
            />
          )}
        </div>*/
      ))}
    </>
  );
}
